import { useRef, useEffect, useState } from 'react';
import { reviews } from '../../../mocks/homeData';

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`ri-star-fill text-sm ${star <= rating ? 'text-[#C4A882]' : 'text-[#E0D8CE]'}`}
        ></i>
      ))}
    </div>
  );
}

const avatarColors = ['#8B7355', '#7A8C6E', '#C4A882', '#9B8E82', '#6B5F52', '#A09080'];

export default function ReviewsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="reviews" className="bg-[#F5F0E8] py-24 px-6" ref={sectionRef}>
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-[#8B7355] text-xs font-medium tracking-[0.3em] uppercase mb-3">Reviews</p>
          <h2 className="text-[#2C2825] text-4xl lg:text-5xl font-light mb-4">
            고객 후기
          </h2>
          <p className="text-[#6B5F52] text-base">
            위딘과 함께 건강한 변화를 경험한 분들의 이야기
          </p>
          <div className="flex items-center justify-center gap-2 mt-4">
            {[1,2,3,4,5].map(s => (
              <i key={s} className="ri-star-fill text-[#C4A882] text-lg"></i>
            ))}
            <span className="text-[#2C2825] font-medium ml-2">5.0</span>
            <span className="text-[#9B8E82] text-sm">/ 50,000+ 리뷰</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((review, i) => (
            <div
              key={review.id}
              className={`bg-white rounded-2xl p-6 border border-[#EDE6DB] transition-all duration-500 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-medium flex-shrink-0"
                    style={{ backgroundColor: avatarColors[i % avatarColors.length] }}
                  >
                    {review.name[0]}
                  </div>
                  <div>
                    <p className="text-[#2C2825] text-sm font-medium">{review.name}</p>
                    <p className="text-[#9B8E82] text-xs">{review.age} · {review.date}</p>
                  </div>
                </div>
                <StarRating rating={review.rating} />
              </div>
              <h4 className="text-[#2C2825] text-sm font-medium mb-2">{review.title}</h4>
              <p className="text-[#6B5F52] text-sm leading-relaxed mb-3">{review.content}</p>
              <span className="inline-block bg-[#F5F0E8] text-[#8B7355] text-xs px-3 py-1 rounded-full">
                {review.product}
              </span>
            </div>
          ))}
        </div>

        <div className={`text-center mt-10 transition-all duration-700 delay-700 ${visible ? 'opacity-100' : 'opacity-0'}`}>
          <button className="border border-[#8B7355] text-[#8B7355] px-8 py-3 rounded-full text-sm font-medium hover:bg-[#8B7355] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap">
            후기 더 보기
          </button>
        </div>
      </div>
    </section>
  );
}
